module.exports = __webpack_public_path__ + "img/dynamic-15.b1e60977.png";